import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import type { ColumnKey, Columns, Store } from '../../../store/list/types';

/**
 * Update model and localstorage with columns.
 */
export const saveConfigColumnsVisibility = (store: Store, updatedColumns: Columns): void => {
  const { setColumns } = store.getState();
  const updatedColumnsKeys = Object.keys(updatedColumns) as ColumnKey[];
  const newConfigColumns: Partial<Record<ColumnKey, boolean>> = {};

  setColumns(updatedColumns);

  updatedColumnsKeys.forEach((column) => {
    newConfigColumns[column] = updatedColumns[column].show;
  });

  LocalStorage.set('playbacksColumnsVisibilityState', newConfigColumns);
};
